import React from 'react';
import { NeedsAttentionItem } from '../../../../services/salesAnalyticsApi';
import styles from './NeedsAttentionList.module.css';

interface NeedsAttentionListProps {
  items: NeedsAttentionItem[];
}

const WarningIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor"><path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"/></svg>
);

/**
 * VP-ADM-001 — "Needs Attention" exception queue.
 * Backed by AdminDashboard.needs_attention: lapsed customers (no order in
 * 30-90 days) and orders sold below cost (negative margin).
 */
export const NeedsAttentionList: React.FC<NeedsAttentionListProps> = ({ items }) => {
  if (items.length === 0) {
    return <div className={styles.empty}>Nothing needs attention right now.</div>;
  }
  return (
    <div className={styles.list}>
      {items.map((item, idx) => (
        <div
          key={idx}
          className={`${styles.item} ${item.type === 'negative_margin_order' ? styles.itemNegativeMargin : ''}`}
        >
          <span className={styles.icon}><WarningIcon /></span>
          <div className={styles.body}>
            <p className={styles.label}>{item.label}</p>
            <p className={styles.detail}>{item.detail}</p>
          </div>
        </div>
      ))}
    </div>
  );
};
